import { render, staticRenderFns } from "./TableInspectDivision.vue?vue&type=template&id=96d2e80a&scoped=true&"
import script from "./TableInspectDivision.vue?vue&type=script&lang=js&"
export * from "./TableInspectDivision.vue?vue&type=script&lang=js&"
import style0 from "./TableInspectDivision.vue?vue&type=style&index=0&id=96d2e80a&prod&scoped=true&lang=scss&"
import style1 from "./TableInspectDivision.vue?vue&type=style&index=1&id=96d2e80a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d2e80a",
  null
  
)

export default component.exports